var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ex-slick"},[(_vm.length > _vm.lengthCards)?_c('slick',_vm._g(_vm._b({ref:"slick",attrs:{"options":_vm.slickOptionsValue}},'slick',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }